
/* eslint-disable max-classes-per-file */

import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export abstract class ExtraInmatningshandelssortimentBaseCommand extends BasicCommand<ExtraInmatningshandelssortimentBaseCommand> {
    destineringId: number;
    violId: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "DestineringExtraInmatningshandelssortiment";
    get primaryKey(): IPrimaryKey<IExtraInmatningshandelssortimentBaseCommandPrimaryKey> {
        return {
            destineringId: this.destineringId,
            violId: this.violId
        };
    }
    constructor($type, commandType) {
        super($type, ExtraInmatningshandelssortimentBaseCommand.$groupKey, commandType);
    }
}

interface IExtraInmatningshandelssortimentBaseCommandPrimaryKey {
    destineringId: number;
    violId: string;
}

export class AddExtraInmatningshandelssortimentCommand extends ExtraInmatningshandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddExtraInmatningshandelssortimentCommand";
    constructor(init: (instance: AddExtraInmatningshandelssortimentCommand) => void) {
        super(AddExtraInmatningshandelssortimentCommand.$type, CommandType.Insert);
        init(this);
    }
}

export class RemoveExtraInmatningshandelssortimentCommand extends ExtraInmatningshandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "RemoveExtraInmatningshandelssortimentCommand";
    constructor(init: (instance: RemoveExtraInmatningshandelssortimentCommand) => void) {
        super(RemoveExtraInmatningshandelssortimentCommand.$type, CommandType.Delete);
        init(this);
    }
}
